import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {todosRoutesPath} from './path';

const ToDosPage = Loadable(
  lazy(() =>
    import('@src/v2/pages/ToDos' /* webpackChunkName: "todos-page" */).then(
      module => ({default: module.ToDosPage}),
    ),
  ),
);
const MyCalendarPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/MyCalendar' /* webpackChunkName: "my-calendar-page" */
    ).then(module => ({default: module.MyCalendarPage})),
  ),
);
const SingleEventPage = Loadable(
  lazy(() =>
    import(
      '@src/v2/pages/SingleEvent' /* webpackChunkName: "single-event-page" */
    ).then(module => ({default: module.SingleEventPage})),
  ),
);

export const todosRoutes = [
  {
    element: <ToDosPage />,
    path: todosRoutesPath.todos.$path(),
  },
  {
    element: <SingleEventPage />,
    path: todosRoutesPath.event.$path(),
  },
  {
    element: <SingleEventPage />,
    path: todosRoutesPath.eventPage.$path(),
  },
  {
    element: <MyCalendarPage />,
    path: todosRoutesPath.availability.$path(),
  },
] satisfies RouteConfig[];
